import Splide from "@splidejs/splide";
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["carouselWrap"];
  initialize() {
    const primarySlider = new Splide(this.carouselWrapTarget, {
      type: "loop",
      perPage: 1,
      pagination: true,
      perPage: 1,
      padding: "14vw",
      autoplay: true,
      interval: 15000,
    });

    primarySlider.mount();
  }
}
